import AuthAdapter from './base';

export default class Status extends AuthAdapter {
  modelNamePlural = 'status';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('statuses', 'status')
      .toLowerCase();
  }
}
